/* Reaper Apparel holding page: countdown, lantern light, password-panel helper. */
(function () {
  var root = document.querySelector('.rg');
  if (!root) return;

  // Countdown to the date in data-launch (ISO format with timezone).
  var target = Date.parse(root.getAttribute('data-launch') || '');
  var count = root.querySelector('[data-rg-count]');

  if (count && !isNaN(target)) {
    var cells = {
      d: count.querySelector('[data-unit="d"]'),
      h: count.querySelector('[data-unit="h"]'),
      m: count.querySelector('[data-unit="m"]'),
      s: count.querySelector('[data-unit="s"]')
    };
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };

    var tick = function () {
      var diff = target - Date.now();
      if (diff <= 0) {
        root.classList.add('rg--open');
        count.hidden = true;
        var openText = root.querySelector('.rg-open-text');
        if (openText) openText.hidden = false;
        return false;
      }
      var total = Math.floor(diff / 1000);
      cells.d.textContent = pad(Math.floor(total / 86400));
      cells.h.textContent = pad(Math.floor((total % 86400) / 3600));
      cells.m.textContent = pad(Math.floor((total % 3600) / 60));
      cells.s.textContent = pad(total % 60);
      return true;
    };

    if (tick()) {
      var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000);
    }
  }

  // A soft light follows the cursor on desktop.
  var light = root.querySelector('.rg-light');
  var finePointer = window.matchMedia('(pointer: fine)').matches;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (light && finePointer && !calm) {
    var x = 50, y = 28, frame = 0;
    window.addEventListener('pointermove', function (e) {
      x = (e.clientX / window.innerWidth) * 100;
      y = (e.clientY / window.innerHeight) * 100;
      if (!frame) {
        frame = requestAnimationFrame(function () {
          frame = 0;
          root.style.setProperty('--rg-x', x + '%');
          root.style.setProperty('--rg-y', y + '%');
        });
      }
    }, { passive: true });
  }

  // Keep the owner password panel open if the password was wrong.
  var owner = root.querySelector('.rg-owner');
  if (owner && owner.querySelector('.rg-msg--err')) owner.open = true;
})();
